import React from 'react';
import styles from './CategoryTable.module.css';
import { CategoryItem } from '../categoriesTypes';
import { RowActionsMenu } from '../../../../components/RowActionsMenu';

interface CategoryTableProps {
  items: CategoryItem[];
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
}

const MarginBar: React.FC<{ margin: number }> = ({ margin }) => {
  // Color based on margin level
  let barColor: string;
  if (margin >= 30) barColor = '#22C55E';
  else if (margin >= 25) barColor = '#10B981';
  else if (margin >= 20) barColor = '#3B82F6';
  else barColor = '#F97316';

  const width = Math.min((margin / 40) * 100, 100);

  return (
    <div className={styles.marginCell}>
      <span className={styles.marginValue} style={{ color: barColor }}>{margin.toFixed(1)}%</span>
      <div className={styles.marginBarTrack}>
        <div className={styles.marginBarFill} style={{ width: `${width}%`, background: barColor }} />
      </div>
    </div>
  );
};

const FastMoversBadge: React.FC<{ count: number }> = ({ count }) => {
  const isHigh = count >= 4;
  return (
    <span className={`${styles.fastBadge} ${isHigh ? styles.fastBadgeHigh : styles.fastBadgeNormal}`}>
      {count} SKUs
    </span>
  );
};

export const CategoryTable: React.FC<CategoryTableProps> = ({ items, onEdit, onDelete }) => {
  const showActions = !!(onEdit || onDelete);
  return (
    <div className={styles.tableWrapper}>
      <div className={styles.tableHeader}>
        <h3 className={styles.tableTitle}>Category Performance</h3>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.thCategory}>CATEGORY</th>
            <th className={styles.thRight}>SKU COUNT</th>
            <th className={styles.thRight}>TOTAL STOCK</th>
            <th className={styles.thRight}>REVENUE</th>
            <th>AVG MARGIN</th>
            <th className={styles.thCenter}>FAST MOVERS</th>
            <th className={styles.thRight}>GROWTH</th>
            {showActions && <th></th>}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id} className={styles.row}>
              <td className={styles.categoryName}>{item.name}</td>
              <td className={styles.numericCell}>{item.skuCount}</td>
              <td className={styles.numericCell}>{item.totalStock.toLocaleString()}</td>
              <td className={styles.numericCell}>${item.revenue.toLocaleString()}</td>
              <td>
                <MarginBar margin={item.avgMargin} />
              </td>
              <td className={styles.centerCell}>
                <FastMoversBadge count={item.fastMovers} />
              </td>
              <td className={`${styles.numericCell} ${styles.growthValue}`}>
                +{item.growth.toFixed(1)}%
              </td>
              {showActions && (
                <td>
                  <RowActionsMenu
                    onEdit={onEdit ? () => onEdit(item.id) : undefined}
                    onDelete={onDelete ? () => onDelete(item.id) : undefined}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
